export default {
  app_title: "Prezzi carburante",
  fuel_label: "Carburante",
  fuel_95: "Benzina 95",
  fuel_98: "Benzina 98",
  fuel_diesel: "Diesel",
  region_label: "Regione",
  region_all: "Tutta la Spagna",
  list_header: "Carburante più economico nelle vicinanze",
  list_show_all: "Mostra tutti",
  list_empty: "Nessuna stazione in quest'area",
  list_expand: "Espandi elenco",
  list_collapse: "Comprimi elenco",
  card_navigate: "Maps",
  locate_me: "Trovami",
  no_location_permission: "Permesso negato",
  loading: "Caricamento...",
  error_loading: "Errore di caricamento",
  attribution: "© OpenStreetMap, CartoDB",
  expand_map: "Espandi mappa",
  collapse_map: "Riduci mappa",
  station_count: "stazioni",
  gesture_hint: "Usa due dita per spostare la mappa",
};
